import React from 'react';
import { useTranslation } from 'react-i18next';
import { FOCUS_VIEW, RULE_INPUT_PARAMETER_NAMES } from 'Common/enums';
import { FormikFieldString } from 'Components/FormikComponents';
import { HandleBlur, HandleChange } from 'Components/MerchantOverviewModal/types';

import styles from './ConclusionTemplated.css';

type Props = {
    error: boolean;
    errorMsg: string;
    outputDescription: string;
    score: number;
    isSubmitting: boolean;
    handleChange: HandleChange;
    handleBlur: HandleBlur;
};

const isOutputDescAcceptOrReject = (outputDescription: string) => {
    return (
        outputDescription === FOCUS_VIEW.ACCEPT ||
        outputDescription === FOCUS_VIEW.REJECT ||
        outputDescription === FOCUS_VIEW.REVIEW
    );
};

const ConclusionTemplated = ({
    error,
    isSubmitting,
    handleChange,
    handleBlur,
    outputDescription,
    score,
    errorMsg
}: Props) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={styles.conclusionStatementTextBar}>
                <div className={styles.conclusionColumn}>
                    <span className={styles.statementSideLabel}>{t('THEN')}</span>
                </div>

                <div className={styles.conclusionColumn}>
                    {isOutputDescAcceptOrReject(outputDescription) ? (
                        <span className={styles.readOnlyValue}>{`${outputDescription}`}</span>
                    ) : (
                        <div className={styles.readOnlyValue}>{t('Update score by', { score })}</div>
                    )}
                </div>

                {!isOutputDescAcceptOrReject(outputDescription) && (
                    <div className={styles.conclusionColumn}>
                        <FormikFieldString
                            dataTestId='conclusion-field'
                            id={RULE_INPUT_PARAMETER_NAMES.SCORE}
                            name={RULE_INPUT_PARAMETER_NAMES.SCORE}
                            type='number'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            className={styles.conclusionValueInput}
                            error={error}
                            errorMsg={errorMsg}
                            disabled={isSubmitting}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default React.memo(ConclusionTemplated);
